"use client";

// プロフィール（練習タイプ）を書き換えたことを、表示中の画面へ知らせるための小さなストア。
//
// useCareerStage は /users/me を1度だけ取得してキャッシュするため、更新しても
// 再読み込みまで古い値が残る。とくに新規登録直後は「練習タイプを選んだのに
// ヘッダーのバッジが出ない」という形で表に出る。
//
// 更新は以下の経路から起きる。いずれも成功後に notifyProfileChanged を呼ぶ。
//   1. lib/auth.tsx        未ログイン時に選んだ区分のサインイン時引き継ぎ
//   2. CareerStageGuard    区分未設定をブロックするダイアログでの確定
//   3. CareerStageGuard    上記引き継ぎが競合したときの保険パッチ
//   4. プロフィール画面     就活 → 転職 への切り替え
//
// このモジュールは lib/auth.tsx からも参照するため、useCareerStage 側には置けない
// （useCareerStage が useAuth を参照しており、循環 import になる）。

// 「何世代目の取得か」を表す通し番号。更新のたびに増やす。
// useCareerStage は取得結果をこの番号ごとにキャッシュするため、番号が変われば
// 購読中の画面が何枚あっても取得は1回で済む。
let revision = 0;

const listeners = new Set<() => void>();

export function subscribeProfileRevalidation(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getProfileRevision(): number {
  return revision;
}

// サーバ側の描画には更新履歴が無いので、常に初期値を返す。
export function getServerProfileRevision(): number {
  return 0;
}

/** プロフィールを更新したあとに呼ぶ。購読中の画面に取り直させる。 */
export function notifyProfileChanged(): void {
  revision += 1;
  for (const listener of listeners) listener();
}

// テストが世代番号を持ち越さないようにするための後始末。
export function resetProfileRevision(): void {
  revision = 0;
  listeners.clear();
}
